var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 4.82422H4.25C4.05109 4.82422 3.86032 4.90324 3.71967 5.04389C3.57902 5.18454 3.5 5.37531 3.5 5.57422C3.5 5.77313 3.57902 5.9639 3.71967 6.10455C3.86032 6.2452 4.05109 6.32422 4.25 6.32422H5V19.8242C5 20.222 5.15804 20.6036 5.43934 20.8849C5.72064 21.1662 6.10218 21.3242 6.5 21.3242H18.5C18.8978 21.3242 19.2794 21.1662 19.5607 20.8849C19.842 20.6036 20 20.222 20 19.8242V6.32422H20.75C20.9489 6.32422 21.1397 6.2452 21.2803 6.10455C21.421 5.9639 21.5 5.77313 21.5 5.57422C21.5 5.37531 21.421 5.18454 21.2803 5.04389C21.1397 4.90324 20.9489 4.82422 20.75 4.82422ZM18.5 19.8242H6.5V6.32422H18.5V19.8242ZM8 2.57422C8 2.37531 8.07902 2.18454 8.21967 2.04389C8.36032 1.90324 8.55109 1.82422 8.75 1.82422H16.25C16.4489 1.82422 16.6397 1.90324 16.7803 2.04389C16.921 2.18454 17 2.37531 17 2.57422C17 2.77313 16.921 2.9639 16.7803 3.10455C16.6397 3.2452 16.4489 3.32422 16.25 3.32422H8.75C8.55109 3.32422 8.36032 3.2452 8.21967 3.10455C8.07902 2.9639 8 2.77313 8 2.57422Z",
    fill: "#B40030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5e392887cc54bca0f22220467714f166.svg";
export { ForwardRef as ReactComponent };